import React from "react";
import styles from "./MailInviteContent.module.css"; // <-- updated to CSS module

const MailInviteContent = ({
  schoolName,
  email,
  password,
  salutation = "Hello Parent",
}) => {
  const handleShare = async () => {
    const text = `
${salutation},

Welcome to ${schoolName}!
${schoolName} has invited you on the Illumine app.

It helps parents stay connected with their child throughout the day.
It only takes two steps to get started.

Instructions:
1. Download the Illumine app from the Apple App Store or Google Play.
   Get it on Google Play: https://play.google.com
   Get it on AppStore: https://apps.apple.com

Or

Open in Web: https://school.illumine.app

2. Login using your registered mobile number.

Email: ${email}
Password: ${password}

Quick things to do after sign-in:
Go to your profile and add your photo. Make sure your contact info is updated.

Questions? Contact us at info@illumine.app
Thanks,
${schoolName}
    `;

    if (navigator.share) {
      try {
        await navigator.share({
          title: `Invitation from ${schoolName}`,
          text,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      alert("Sharing is not supported on this browser.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>{salutation},</p>
        <button onClick={handleShare} className={styles.shareButton}>
          Share
        </button>
      </div>

      <p className={styles.welcomeText}>
        Welcome to <strong>{schoolName}</strong>!<br />
        {schoolName} has invited you on the Illumine app.
      </p>

      <p>
        It helps parents stay connected with their child throughout the day.
        <br />
        It only takes two steps to get started.
      </p>

      <p className={styles.sectionTitle}>Instructions:</p>

      <ol>
        <li>
          Download the Illumine app from the Apple App Store or Google Play.
          <ul>
            <li>
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noreferrer"
              >
                Get it on Google Play
              </a>
            </li>
            <li>
              <a href="https://apps.apple.com" target="_blank" rel="noreferrer">
                Get it on AppStore
              </a>
            </li>
          </ul>
        </li>
        <li>
          Or open in Web:{" "}
          <a
            href="https://school.illumine.app"
            target="_blank"
            rel="noreferrer"
          >
            https://school.illumine.app
          </a>
        </li>
        <li>
          Login using your registered mobile number.
          <br />
          <br />
          Email: <strong>{email}</strong>
          <br />
          Password: <strong>{password}</strong>
        </li>
      </ol>

      <p className={styles.sectionTitle}>Quick things to do after sign-in:</p>
      <p>
        Go to your profile and add your photo. Make sure your contact info is
        updated.
      </p>

      <p>
        Questions? Contact us at{" "}
        <a href="mailto:info@illumine.app">info@illumine.app</a>
      </p>

      <p>We hope you will enjoy our service.</p>

      <p className={styles.thanks}>
        Thanks,
        <br />
        <strong>{schoolName}</strong>
      </p>
    </div>
  );
};

export default MailInviteContent;
